import React from 'react';
import moment from 'moment';

import { getDaysOnMarketAt } from 'common/listingHelpers';

import { formatPrice } from 'common/formatters';

import {
  DATA_TABLE_SOURCE_LISTING_CMA_HISTORY,
  DATA_TABLE_VIEW_ID_LISTING_CMA_HISTORY,
} from 'common/dataTableConstants';

import { SR_TABLE_THEME_HISTORICAL } from 'client/components/SrTable';
import SrDataTableUI from 'client/components/SrDataTableUI';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrText from 'client/components/SrText';

function getDataTableSettingsFromProps({ listingId }) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_LISTING_CMA_HISTORY,
    rootViewId: DATA_TABLE_VIEW_ID_LISTING_CMA_HISTORY,
    viewId: `${DATA_TABLE_VIEW_ID_LISTING_CMA_HISTORY}_${listingId}`,
    initialViewSettings: {
      filter: {
        'comparativeMarketAnalysis.listingId': listingId,
      },
      loadAllData: true,
    },
    itemsPropName: 'cmas',
  };
  return dataTableSettings;
}

const SrCMAHistoryDataTable = ({ listingId }) => {
  const formatDate = (date) => {
    return moment(date).format('MM/DD/YYYY');
  };

  const headers = [
    {
      content: 'Date',
      width: '25%',
    },
    {
      content: 'DOM',
      width: '25%',
    },
    {
      content: 'Listed Price',
      width: '25%',
    },
    {
      content: 'CMA Price',
      dataTableFieldId: 'rentPrice',
      width: '25%',
    },
  ];

  return (
    <div>
      <SrDataTableConnected {...getDataTableSettingsFromProps({ listingId })}>
        {({
          cmas,
          viewSettings,
          dataTableApiState,
          onInfiniteScrollWrapperRef,
          dataTableIsFullyLoaded,
        }) => {
          // eslint-disable-line max-len
          if (dataTableApiState.inProgress && cmas.length === 0) {
            return (
              <div>
                <div className="loading-gif clearfix" />
              </div>
            );
          }
          if (cmas.length === 0 && dataTableIsFullyLoaded) {
            return (
              <SrText font="greycliff" weight="500" fontSize="16px">
                There are no CMAs for this listing.
              </SrText>
            );
          }
          return (
            <div ref={onInfiniteScrollWrapperRef}>
              <SrDataTableUI
                sticky
                theme={SR_TABLE_THEME_HISTORICAL}
                dataTableViewSettings={viewSettings}
                headers={headers}
                minWidth="100%"
                rows={cmas.map((cma) => {
                  return {
                    cells: [
                      {
                        content: formatDate(cma.createdAt),
                      },
                      {
                        content: cma.daysOnMarketWhenCreated
                          ? cma.daysOnMarketWhenCreated
                          : getDaysOnMarketAt({
                              listing: cma.listing,
                              date: cma.createdAt,
                            }),
                      },
                      {
                        content: formatPrice(
                          cma.listedListingPrice || cma.latestPriceUpdate || cma.listingPrice,
                        ),
                      },
                      {
                        content: formatPrice(cma.rentPrice),
                      },
                    ],
                  };
                })}
              />
              {dataTableApiState.inProgress && (
                <div>
                  <div className="loading-gif clearfix" />
                </div>
              )}
            </div>
          );
        }}
      </SrDataTableConnected>
    </div>
  );
};

SrCMAHistoryDataTable.displayName = 'SrCMAHistoryDataTable';

export default SrCMAHistoryDataTable;
